import React from 'react'
import {useTranslation, Trans} from "react-i18next";
import {Info} from "react-feather";

interface CreateCommentNeedsLoginProps {
  triggerLogin?: () => void
}

export function CreateCommentNeedsLogin({triggerLogin}: CreateCommentNeedsLoginProps) {
  const {t} = useTranslation('liveblog')

  return <div className="tik4-create-comment">

  { triggerLogin &&
    <button className="tik4-form-field tik4-form-field--sm tik4-comments__write__button" onClick={triggerLogin} type="button">{t('liveblog.comments.button.comment.generic')}</button>
  }

  <div className="tik4-hint tik4-hint--sm tik4-comments__write__hint">
    <Info className="tik4-icon" />
    <div className="tik4-hint__content">
      { triggerLogin ?
        <Trans i18nKey="liveblog.comments.login.with_button">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          Please <a href="#" className="tik4-link tik4-link--within-body" onClick={triggerLogin}>log in</a> to comment this message.
        </Trans>
        :
        t('liveblog.comments.login.no_button')
      }
    </div>
  </div>
</div>
}
